import { List, ListItem, Text } from "@certn/cascadia-react";
import { css } from "@emotion/css";

import { useCanViewClientPortalPricing } from "../../permissions/Permissions";
import { formatNullableCurrency } from "../../../utils/formatNullableCurrency";

interface Props {
  checks: {
    id: string;
    name: string;
    selectedOptionName?: string;
    selectedOptionNames?: string[];
  }[];
  name: string;
  price?: number | null;
  title: string;
  currency?: string;
}

export function SummaryItemWithChecks({
  checks,
  name,
  price,
  title,
  currency,
}: Props) {
  const canViewClientPortalPricing = useCanViewClientPortalPricing();
  const amount = formatNullableCurrency(price, {
    currency,
    locale: "en-US",
    fallback: null,
  });

  return (
    <div>
      <div className={styles.spaceBetween}>
        <div className={styles.flexColumn}>
          <Text style="summary/section-title">{title}</Text>
          <Text style="global/heading-small" testID="summary-bundle-title">
            {name}
          </Text>
        </div>
        {canViewClientPortalPricing && amount && (
          <Text testID="summary-bundle-price">{amount}</Text>
        )}
      </div>
      <List type="unordered" marginTop="space-2">
        {checks.map((check) => (
          <ListItem key={check.id}>
            <Text as="div" testID="summary-bundle-check">
              {check.name}
            </Text>
            {check.selectedOptionNames &&
            check.selectedOptionNames.length > 0 ? (
              <List type="unordered" marginTop="space-1">
                {check.selectedOptionNames.map((optionName, index) => (
                  <ListItem key={index} size="secondary">
                    <Text
                      as="div"
                      style="global/metric-detail"
                      color="text-weak"
                      testID="summary-bundle-check-option"
                    >
                      {optionName}
                    </Text>
                  </ListItem>
                ))}
              </List>
            ) : (
              check.selectedOptionName && (
                <Text
                  as="div"
                  style="global/metric-detail"
                  color="text-weak"
                  testID="summary-bundle-check"
                >
                  {check.selectedOptionName}
                </Text>
              )
            )}
          </ListItem>
        ))}
      </List>
    </div>
  );
}

const styles = {
  spaceBetween: css({
    display: "flex",
    justifyContent: "space-between",
  }),
  flexColumn: css({
    display: "flex",
    flexDirection: "column",
  }),
};
